import React from 'react';
import Tooltip from '../../../../components/Tooltip';
import AutoWidthSelect from './AutoWidthSelect';
import { getDoDStatusColor } from '../utils/dodUtils';

export default function SubEpicDoDSection({
  disciplines,
  doDsByDiscipline,
  modalChildDoDStatuses,
  setModalChildDoDStatuses,
  modalChildDoDEditMode,
  setModalChildDoDEditMode,
  editDisciplinesButtonHovered,
  setEditDisciplinesButtonHovered
}) {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <label style={{ fontSize: 14, fontWeight: 'bold', color: '#111' }}>Definition of Done</label>
        <button
          type="button"
          onClick={() => setModalChildDoDEditMode(!modalChildDoDEditMode)}
          onMouseEnter={() => setEditDisciplinesButtonHovered(true)}
          onMouseLeave={() => setEditDisciplinesButtonHovered(false)}
          style={{
            padding: '2px 6px',
            borderRadius: 4,
            border: 'none',
            background: modalChildDoDEditMode 
              ? (editDisciplinesButtonHovered ? '#229955' : '#27ae60')
              : (editDisciplinesButtonHovered ? '#f5f5f5' : '#fff'),
            color: modalChildDoDEditMode ? '#fff' : '#111',
            fontSize: 10,
            fontWeight: 'normal',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            position: 'relative',
            transition: 'background 0.2s',
          }}
        >
          <span
            className="edit-pen-icon"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 14,
              width: 14,
              color: modalChildDoDEditMode ? '#fff' : '#555',
            }}
          >
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" fill="currentColor" stroke="currentColor" strokeWidth="0.5"/>
            </svg>
          </span>
          <span>{modalChildDoDEditMode ? 'Done' : 'Edit'}</span>
        </button>
      </div>
      <div style={{ 
        display: 'block',
        borderRadius: 4,
        paddingLeft: 8,
        paddingRight: 8
      }}>
        {disciplines
          .filter(discipline => discipline.excludeFromDoDs !== true)
          .map(discipline => {
          const hidden = (modalChildDoDStatuses._hidden || []).includes(discipline.id);
          const disciplineDoDs = doDsByDiscipline[discipline.name] || [];
          
          // In edit mode, show all disciplines with hide/show toggle
          // In normal mode, only show non-hidden disciplines
          if (!modalChildDoDEditMode && hidden) {
            return null;
          }
          
          return (
            <div 
              key={discipline.id} 
              style={{ 
                display: 'inline-block',
                marginRight: 8,
                marginBottom: 8,
                background: hidden ? '#f5f5f5' : 'transparent',
                borderRadius: 4,
                opacity: hidden ? 0.6 : 1,
                verticalAlign: 'top'
              }}
            >
              {modalChildDoDEditMode && (
                <input
                  type="checkbox"
                  checked={!hidden}
                  onChange={(e) => {
                    const newStatuses = { ...modalChildDoDStatuses };
                    if (!newStatuses._hidden) {
                      newStatuses._hidden = [];
                    }
                    if (e.target.checked) {
                      // Show discipline - remove from hidden array
                      newStatuses._hidden = newStatuses._hidden.filter(id => id !== discipline.id);
                      // If hidden array is empty, remove it
                      if (newStatuses._hidden.length === 0) {
                        delete newStatuses._hidden;
                      }
                    } else {
                      // Hide discipline - add to hidden array
                      if (!newStatuses._hidden.includes(discipline.id)) {
                        newStatuses._hidden.push(discipline.id);
                      }
                      // Remove DoD status for hidden discipline
                      delete newStatuses[discipline.id];
                    }
                    setModalChildDoDStatuses(newStatuses);
                  }}
                  style={{ 
                    cursor: 'pointer',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 6
                  }}
                />
              )}
              <div style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                {(() => {
                  const statusColor = getDoDStatusColor(modalChildDoDStatuses[discipline.id] || "", disciplineDoDs);
                  const pillColor = statusColor || discipline.color;
                  
                  // Create tooltip content showing all DoD states and their definitions
                  const tooltipContent = disciplineDoDs.length > 0
                    ? (
                        <div style={{ lineHeight: '1.5' }}>
                          {disciplineDoDs.map((dod, index) => {
                            const isCurrent = dod.id === modalChildDoDStatuses[discipline.id];
                            return (
                              <div key={dod.id} style={{ marginBottom: index < disciplineDoDs.length - 1 ? '12px' : 0 }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                                  {isCurrent && '→ '}
                                  {dod.name}
                                </div>
                                <div style={{ paddingLeft: '12px', fontSize: 11 }}>
                                  {dod.description.split('\n').map((line, lineIndex) => (
                                    <div key={lineIndex}>{line}</div>
                                  ))}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )
                    : 'No Definition of Done states defined for this discipline.';
                  
                  return (
                    <Tooltip 
                      content={tooltipContent}
                      tooltipStyle={{ 
                        maxWidth: 400,
                        padding: '12px 16px',
                        fontSize: 11,
                        lineHeight: '1.5',
                        textAlign: 'left'
                      }}
                    >
                      <div style={{ 
                        display: 'flex',
                        alignItems: 'center',
                        background: pillColor,
                        borderRadius: 5,
                        overflow: 'hidden',
                        flexShrink: 0
                      }}>
                        <div style={{ 
                          padding: '5px 8px',
                          color: 'white',
                          fontSize: 11,
                          fontWeight: 500,
                          whiteSpace: 'nowrap',
                          marginBottom: 1,
                          userSelect: 'none',
                        }}>
                          {discipline.name}
                        </div>
                        {disciplineDoDs.length > 0 ? (
                          <AutoWidthSelect
                            value={modalChildDoDStatuses[discipline.id] || ""}
                            onChange={e => {
                              const newStatuses = { ...modalChildDoDStatuses };
                              if (e.target.value) {
                                newStatuses[discipline.id] = e.target.value;
                              } else {
                                delete newStatuses[discipline.id];
                              }
                              setModalChildDoDStatuses(newStatuses);
                            }}
                            disabled={hidden}
                            disciplineColor={discipline.color}
                            options={disciplineDoDs}
                            statusColor={statusColor}
                          />
                        ) : (
                          <div style={{ 
                            padding: '6px 12px',
                            fontSize: 11, 
                            color: '#999', 
                            fontStyle: 'italic',
                            background: '#fff',
                            borderLeft: `2px solid ${pillColor}`
                          }}>
                            No DoDs
                          </div>
                        )}
                      </div>
                    </Tooltip>
                  );
                })()}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

